import React from "react";
import { iconClassNames } from "../../assets/style/theme/icon-classes";
import { useCookieContext } from "contexts";

interface FormTextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  placeholder?: string;
  label?: string;
  required?: boolean;
  error?: string;
  correctValueMessage?: string;
  inputClassName?: string;
  labelClassName?: string;
  iconClassName?: keyof typeof iconClassNames;
  wrapperClassName?: string;
  leftElement?: React.ReactNode;
  withAsterisk?: boolean;
}

const FormTextArea = React.forwardRef<HTMLTextAreaElement, FormTextAreaProps>(
  (
    {
      placeholder,
      label,
      required,
      error,
      correctValueMessage,
      inputClassName,
      labelClassName,
      iconClassName,
      wrapperClassName,
      leftElement,
      readOnly,
      withAsterisk,
      rows = 5,
      ...rest
    },
    ref,
  ) => {
    const { isRTL } = useCookieContext();

    return (
      <div className={wrapperClassName}>
        {label && (
          <div className={`mb-1 ${labelClassName} position-relative`}>
     
            <label className={`${withAsterisk ? "px-2" : ""}`}>{label}</label>
              {withAsterisk && (
                  <span
                      className={` text-danger`}
                      style={{
                          fontSize: "0.75rem",
                      }}
                  >
                *
              </span>
              )}
          </div>
        )}
        <div
          className={`position-relative  ${error ? "invalid-input-wrapper" : ""} ${
            iconClassName ? "input-with-icon" : ""
          } ${readOnly ? "pe-none" : ""}`}
        >
          <textarea
            rows={5}
            className={`form-control ${error ? "is-invalid" : ""} ${inputClassName ? inputClassName : ""}`}
            placeholder={placeholder}
            required={required}
            ref={ref}
            {...rest}
            readOnly={readOnly}
            style={{ resize: "none" }}
          />
          {leftElement && (
            <div
              className={`position-absolute ${
                isRTL ? "start-0" : "end-0"
              } top-50 translate-middle-y px-2 user-select-none`}
            >
              {leftElement}
            </div>
          )}

          {iconClassName && <i className={iconClassName} />}
        </div>
        {error && (
          <div className="invalid-feedback" style={{ display: "block" }}>
            {error}
          </div>
        )}
        {correctValueMessage && <div className="valid-feedback">{correctValueMessage}</div>}
      </div>
    );
  },
);

export default FormTextArea;
